(ns practitest.frontend.license.events
  (:require
   [ajax.core :as ajax]
   [day8.re-frame.http-fx]
   [practitest.frontend.common.dom :as dom]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.common.mixpanel :as mixpanel]
   [practitest.frontend.events :as events]
   [practitest.frontend.routing.backend-routes :as broutes]
   [re-frame.core :as re-frame]))

;; Current model of concurrent licensing seats does not integrate
;; with rails sessions correctly, and there's no good mechanism to force session
;; invalidation on backend, so we're sending this explicit logout request to terminate
;; session when we've got notified about license blocking, otherwise it's really messy
(re-frame/reg-event-fx
  ::logout-current-user
  (fn [{:keys [db]} _]
    {:http-xhrio
     {:method :get
      :uri (broutes/get-url "sessions#destroy")
      :response-format (ajax/raw-response-format)}}))

(re-frame/reg-event-fx
  ::update-license-blocked-status
  (fn [{:keys [db]} [_ license-blocked? message]]
    {:db (assoc db :license-blocked? license-blocked?
                   :license-blocked-reason (:reason message))
     :dispatch (when license-blocked?
                 [::logout-current-user])}))

(defn- check-license-availability
  [{:keys [db]} _]
  {:http-xhrio
   {:method          :get
    :uri             (broutes/get-url "sessions#check_license_availability")
    :response-format (ajax/json-response-format {:keywords? true})
    :on-success      [::handle-license-availability-check]
    :on-failure      [::handle-license-availability-check-error]}})

(re-frame/reg-event-fx
 ::check-license-availability
 check-license-availability)

(re-frame/reg-event-fx
 ::handle-license-availability-check
 (fn [{:keys [db]} [_ response]]
   (if (:seat_available response)
     {:db (assoc db :license-blocked? false)}
     (do
       (mixpanel/track "License Blocked" {:Action "Idle"})
       (dom/navigate! "/logout?license_blocked=true")))))

(re-frame/reg-event-fx
 ::handle-license-availability-check-error
 (fn [{db :db} _]
   {:db db
    :dispatch [::events/api-error ::check-license-availability
               {:message
                (get-translation
                 "license_blocked.check_availablity.error"
                 "An error occurred while checking license availability.")}]}))

(re-frame/reg-sub
 ::license-blocked?
 (fn [db _]
   (:license-blocked? db)))

(re-frame/reg-sub
  ::license-blocked-reason
  (fn [db _]
    (:license-blocked-reason db)))
